export default "__VITE_ASSET__DReJ$3Qx__"